<template>
  <app-page>
    <v-row>
      <v-col
        cols="12" sm="6" md="4" lg="3"
        v-for="shop in shops"
        :key="shop.id"
      >
        <shop-card :shop="shop" />
      </v-col>
    </v-row>
  </app-page>
</template>

<script>
import PageBase from '@/mixins/PageBase'
import ShopCard from './ShopCard'
import * as http from '@/libs/http'

export default {
  name: 'ShopList',
  mixins: [
    PageBase('店舗一覧')
  ],
  components: {
    ShopCard
  },
  data () {
    return {
      shops: {}
    }
  },
  created () {
    this.addFetcher(() => this.fetch())
  },
  methods: {
    async fetch () {
      const shops = await http.request(async api => {
        const resp = await api.get('shops?cat=1')
        if (resp.status === http.OK) {
          return resp.data
        }
        return new http.StatusError(resp)
      })
      if (shops === http.FAILED) {
        return false
      }
      this.shops = shops
      return true
    }
  }
}
</script>
